import React from 'react'
import styled from 'particles/themes/styled'
import BaseSearch from 'particles/Search'
import { MenuItemSize } from '.'
import MenuItemText from './Text'
import { useTranslation } from 'react-i18next'

interface SearchProps {
    size?: MenuItemSize
    onSearch?: (value: string) => void
    onClearSearch?: () => void
    maxHeight?: string
    width?: string
    placeholder?: string
    searchValue?: string
}

const StyledSearchContainer = styled.div`
    position: sticky;
    top: 0;
    background: ${({ theme }) => theme.colors.surface.primary};
    z-index: 2;
    padding-bottom: 4px;
`

const Search: React.FC<SearchProps> = ({ size = 's', onSearch, onClearSearch, placeholder, searchValue }) => {
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        onSearch?.(e.target.value)
    }

    return (
        <StyledSearchContainer>
            <BaseSearch
                onChange={handleSearch}
                onClearSearch={onClearSearch}
                size={size === 's' ? 'xs' : 's'}
                hasSearchButton={false}
                onKeyDown={e => {
                    e.stopPropagation()
                    if (e.key === 'Enter') {
                        e.preventDefault()
                    }
                }}
                placeholder={placeholder}
                searchValue={searchValue}
            />
        </StyledSearchContainer>
    )
}

export const EmptySearchResult: React.FC = () => {
    const [t] = useTranslation()
    return <MenuItemText isDisabled text={t('placeholderText.noSearchResult')} />
}

export default Search
